import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Dropdown from "../UI/Collapsible";
import { links } from "../../utils/constants";

class Sidebar extends Component {
  state = {
    dropdownes: {
      operationRoom: false,
      hr: false,
      finance: false,
      userRelationship: false
    }
  };

  onTriggerClickHandler = value => {
    this.setState(prevState => {
      return {
        dropdownes: {
          operationRoom:
            value === "operationRoom"
              ? !prevState.dropdownes.operationRoom
              : false,
          hr: value === "hr" ? !prevState.dropdownes.hr : false,
          finance: value === "finance" ? !prevState.dropdownes.finance : false,
          userRelationship:
            value === "userRelationship"
              ? !prevState.dropdownes.userRelationship
              : false
        }
      };
    });
  };

  activeClass = pathName =>
    this.props.location.pathname.indexOf("finance") === -1 &&
    this.props.location.pathname.indexOf(pathName) !== -1
      ? "active"
      : null;

  render() {
    const userRelationship = [
      { to: links.users(), label: "User Management" },
      { to: links.marketing(), label: "Marketing" },
      {
        to: links.promotionalCodesManagement(),
        label: "Promotional Codes Management"
      }
    ];
    const hr = [
      { to: links.targets(), label: "Targets" },
      { to: links.saleries(), label: "Salaries" }
    ];
    const finance = [
      { to: links.financeRestaurants(), label: "Restaurants" },
      { to: links.financeDriver(), label: "Drivers" }
    ];
    const operationRoom = [
      { to: links.map(), label: "Map" },
      { to: links.dashboard(), label: "Monitoring Dashboard" },
      { to: links.orders(), label: "Orders" },
      { to: links.liveChat(), label: "Live Chat " }
    ];
    return (
      <aside className="sidebar">
        <ul className="menu">
          <li className="dropdown">
            <Dropdown
              onTriggerClick={() => this.onTriggerClickHandler("operationRoom")}
              open={this.state.dropdownes.operationRoom}
              trigger="Operation Room"
              content={operationRoom}
            />
          </li>
          <li
            className={this.activeClass("/customers")}
            onClick={() => this.onTriggerClickHandler()}
          >
            <Link to="/customers">Customer Administrator</Link>
          </li>
          <li className="dropdown">
            <Dropdown
              onTriggerClick={() =>
                this.onTriggerClickHandler("userRelationship")
              }
              open={this.state.dropdownes.userRelationship}
              trigger="User Relationship"
              content={userRelationship}
            />
          </li>
          <li
            className={this.activeClass("/drivers")}
            onClick={() => this.onTriggerClickHandler()}
          >
            <Link to="/drivers">Driver</Link>
          </li>
          <li className="dropdown">
            <Dropdown
              onTriggerClick={() => this.onTriggerClickHandler("finance")}
              open={this.state.dropdownes.finance}
              trigger="Finance"
              content={finance}
            />
          </li>
          <li className="dropdown">
            <Dropdown
              onTriggerClick={() => this.onTriggerClickHandler("hr")}
              open={this.state.dropdownes.hr}
              trigger="HR"
              content={hr}
            />
          </li>
          <li
            className={this.activeClass("/management-dashboard")}
            onClick={() => this.onTriggerClickHandler()}
          >
            <Link to="/management-dashboard">Management Dashboard</Link>
          </li>
          <li
            className={this.activeClass("/admin-users-management-list")}
            onClick={() => this.onTriggerClickHandler()}
          >
            <Link to="/admin-users-management-list">
              Admin Users Management
            </Link>
          </li>
            <li
                className={this.activeClass("/settings")}
                onClick={() => this.onTriggerClickHandler()}
            >
                <Link to="/settings">Settings</Link>
            </li>
          {/*<li className={ this.activeClass('/live-chat') } onClick={() => this.onTriggerClickHandler()}>*/}
          {/*<Link to="/live-chat">Live Chat</Link>*/}
          {/*</li>*/}
        </ul>
      </aside>
    );
  }
}

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js